import React from "react";
import { IconPathProps } from "../../types";

export const ChevronLeft = ({ lineColor, strokeWidth }: IconPathProps) => (
  <path
    d="M15 4.5L7.5 12L15 19.5"
    stroke={lineColor}
    strokeWidth={strokeWidth}
    strokeLinejoin="round"
  />
);
